import Marquee from "react-fast-marquee";

export default function BrandMarquee({ items, speed = 40, className = "" }) {
  return (
    <div className={`border-y border-[#0A192F]/10 py-6 bg-[#FBF9F5] ${className}`} data-testid="brand-marquee">
      <Marquee gradient={false} speed={speed} pauseOnHover>
        {items.map((it, i) => (
          <span key={i} className="marquee-item text-[#0A192F]/70 font-serif text-3xl md:text-5xl italic">
            {it}
            <span className="w-2 h-2 rounded-full bg-[#C5A059] inline-block" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
